import type {
  StudentResponseEntity,
  StudentStatistics,
} from '@/domains/students/student.entity';

/**
 * Use Case para calcular estadísticas agregadas de estudiantes
 * Cumple SRP: Solo calcula métricas estadísticas
 *
 * Responsabilidades:
 * - Calcular total de estudiantes
 * - Contar estudiantes de alto riesgo
 * - Calcular porcentaje de riesgo alto
 *
 * Inspirado en: ProcessRiskIndicatorsUseCase de centerLayer
 * Extrae lógica que estaba en useStudent.hook.ts (líneas 42-57)
 */
export class CalculateStudentStatisticsUseCase {
  /**
   * Calcula estadísticas agregadas de una lista de estudiantes
   * @param students - Lista de estudiantes a analizar
   * @returns Objeto con estadísticas calculadas
   */
  execute(students: StudentResponseEntity[]): StudentStatistics {
    const totalEstudiantes = students.length;

    if (totalEstudiantes === 0) {
      return {
        totalEstudiantes: 0,
        estudiantesRiesgoAlto: 0,
        porcentajeRiesgoAlto: 0,
      };
    }

    const estudiantesRiesgoAlto = students.filter(
      (student) => student.is_high_risk,
    ).length;

    const porcentajeRiesgoAlto =
      (estudiantesRiesgoAlto / totalEstudiantes) * 100;

    return {
      totalEstudiantes,
      estudiantesRiesgoAlto,
      porcentajeRiesgoAlto: Math.round(porcentajeRiesgoAlto * 100) / 100,
    };
  }
}
